"use strict";

define('evisions/validation',['validator', 'underscore'], function (validator, _) {
  var validation = {},
    wrapper = null,
    defaultMessage = 'This field is invalid.';
  wrapper = function wrapper(fn) {
    return function (message) {
      var args = _.toArray(arguments).slice(1);
      return function (value, field) {
        return fn.apply(this, [value].concat(args)) || message || defaultMessage;
      };
    };
  };
  _.each(validator, function (fn, name) {
    if (name.slice(0, 2) == 'is') {
      name = name.slice(2).toLowerCase();
      validation[name] = wrapper(fn);
    }
  });
  validation.empty = function (message) {
    return function (value) {
      return !!String(value || '').trim() || message || 'You must enter a value.';
    };
  };
  validation.checkLength = function (min, max, minMessage, maxMessage) {
    return function (value, field) {
      if (value) {
        if (value.length < min) {
          return minMessage || 'This field must be a minimum length of ' + min + '.';
        }
        if (value.length > max) {
          return maxMessage || 'This field cannot have a length greater than ' + max + '.';
        }
      }
      return true;
    };
  };
  validation.phone = function (message) {
    return function (value, field) {
      var regex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
      if (!value) {
        return true;
      }
      if (!regex.test(value)) {
        return message || 'An invalid phone number was entered.';
      }
      return true;
    };
  };
  validation.postalCode = function (message) {
    return function (value, field) {
      var regex = /^\d{5}(-\d{4})?$/g;
      if (!value) {
        return true;
      }
      if (!regex.test(value)) {
        return message || 'An invalid postal code was entered.';
      }
      return true;
    };
  };
  validation.date = function (message, force) {
    message = message || 'This is an invalid date.';
    return function (date, field) {
      if (_.isDate(date)) {
        try {
          var time = date.getTime();
          if (_.isNaN(time)) {
            return message;
          }
        } catch (e) {
          return message;
        }
      } else if (force) {
        return message;
      }
      return true;
    };
  };
  validation.number = function (message) {
    message = message || 'This is an invalid number.';
    return function (value, field) {
      if (String(value).length > 0 && _.isNaN(Number(value))) {
        return message;
      } else if (value % 1 != 0) {
        return "Decimal points are not allowed.";
      }
      return true;
    };
  };
  validation.numberBetween = function (min, max, message) {
    message = message || 'This is an invalid number.';
    return function (value, field) {
      if (String(value).length > 0 && _.isNaN(Number(value))) {
        return message;
      } else if (value % 1 != 0) {
        return "Decimal points are not allowed.";
      } else if (value < min || value > max) {
        return message;
      }
      return true;
    };
  };
  return validation;
});

